function toggleAccordion() {
  $('.accordion__title').click(function(e) {
    e.preventDefault();
    var target = $(this).parent().find('.accordion__content');
    var icon = $(this).children('.accordion__icon').children('.icon__accordiontoggle');
    if (target.is(':visible')) {
      $(this).removeClass('js-accordion-active');
      $(icon).removeClass('js-accordion-active');
      target.slideUp(500);
    } else {
      $(this).addClass('js-accordion-active');
      $(icon).addClass('js-accordion-active');
      target.slideDown(500);
    }
  });
  $('.accordion__title:first').children('.accordion__icon').children('.icon__accordiontoggle').addClass('js-accordion-active');
  $('.accordion__content:first').show();

}

toggleAccordion()



// WEBPACK FOOTER //
// ./assets/js/features/accordion.js